let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("ijPJo"), load("8hh2h")]).then(() => parcelRequire('aJZgI'));